import React from "react";
import klarnaIcon from "@/public/icons/klarna_pink.svg";
import { useTemplateStore } from "@/zustand/templateStore";

const KlarnaExpressButton = ({ handleClick }) => {
  const { handlePaymentMethodChange } = useTemplateStore();
  return (
    <button
      className="klarnaButton--express"
      onClick={() => {
        handlePaymentMethodChange("klarna");
        handleClick();
      }}
    >
      <img src={klarnaIcon} height="24" alt="Klarna Express" />
    </button>
  );
};

export default KlarnaExpressButton;
